import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, reinitAction
} from 'one-state-apptreasoncode';


import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    GETDEPTINFO_FETCH = "department-info-fetch/athena",
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',
    SETAPPOINTMENTS = 'set-appointments/set-athena',
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of GetSession
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetApptReasonAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: {
            athenaendpoints: {
                appointmentreasoncodes
            },
            appointment_config: {cancelslot},
            compatible : { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.SETSELECTED_ATHENA),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;
                let  queryString  = `slotavailable=${cancelslot}&limit=1000&offset=0`;
                let fullPath = `${appointmentreasoncodes}?${queryString}`
                const callApptReasonCodeAPI = (datares: any) => {
                    if (datares) {
                        
                        let headers = new Headers();
                        const responsefromAPI = server.get({
                            headers: headers,
                            path: fullPath
                        })
                            .then((responsegetdeptinfo: any) => responsegetdeptinfo)
                            .catch((getdeptinfores: any) => {
                                log.error(
                                    "ccw-gadget,getdeptinfo-athena",
                                    "getdeptinfo-athena", {
                                        getdeptinfores
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"GetApptReason",
                                    type:"error",
                                    status:getdeptinfores?.status,
                                    erroritems:getdeptinfores?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,getapptreason-athena",
                            "getapptreason-athena response", {
                            responsefromAPI
                        });
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                return callApptReasonCodeAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any = [
                                setAction(responseAfterTransform)
                            ];
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
export const clearApptReasonAthena = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, getapptreasocode-athena",
            "clear-getapptreasocode-athena", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, Types.SETSELECTED_ATHENA),
            map(action => reinitAction())
        )

    }
);
